/* Generates a Card component with a label and 5 radio buttons for selecting the
* Score of different categories during the review process
*/

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

import styles from '../App.module.css';


const RadioScore = ( props ) => {
  const [radioValue, setRadioValue] = useState( '0' );

  const scoreButtons = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5', value: '5' }
  ];

  const updateRadioValue = ( val ) => {
    console.log( `${props.catName} Value: ${val}` );
    setRadioValue( val );
    props.set( val );
  };

  return (
    <Card body className={[styles.CardLvl2]}>
      <div className={styles['flex-wrapper']}>
        <div className={styles.revRadioLabel}>{props.catName}</div>
        <InputGroup className={styles.revRadioButtonGroup}>
          {scoreButtons.map( ( radio, idx ) => (
            <Form.Check
              required
              key={`${props.idx}-${idx}`}
              id={`radio-${props.idx}-${idx}`}
              type="radio"
              label={`${idx + 1}`}
              name={`radio-${props.idx}`}
              value={radio.value}
              variant='outline-dark'
              checked={radioValue === radio.value}
              onChange={e => updateRadioValue( e.currentTarget.value )}
            />
          ) )}
        </InputGroup>
      </div>
    </Card>
  );
};

RadioScore.propTypes = {
  idx: PropTypes.string,
  catName: PropTypes.string,
  set: PropTypes.func
};

export default RadioScore;